import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Categories, Category } from '../../../components_renew/Mall/Category'
import xiniu_categoryAll from '../../../assets/xiniu/mall-category-all.png'
import xiniu_category_1 from '../../../assets/xiniu/mall-category-1.png'
import xiniu_category_2 from '../../../assets/xiniu/mall-category-2.png'
import xiniu_category_3 from '../../../assets/xiniu/mall-category-3.png'
import xiniu_category_4 from '../../../assets/xiniu/mall-category-4.png'
import xiniu_category_5 from '../../../assets/xiniu/mall-category-5.png'
import xiniu_category_6 from '../../../assets/xiniu/mall-category-6.png'
import xiniu_category_7 from '../../../assets/xiniu/mall-category-7.png'
import xiniu_category_8 from '../../../assets/xiniu/mall-category-8.png'
import xiniu_category_9 from '../../../assets/xiniu/mall-category-9.png'
import xiniu_category_10 from '../../../assets/xiniu/mall-category-10.png'
import haiou_categoryAll from '../../../assets/haiou/mall-category-all.png'
import haiou_category_1 from '../../../assets/haiou/mall-category-1.png'
import haiou_category_2 from '../../../assets/haiou/mall-category-2.png'
import haiou_category_3 from '../../../assets/haiou/mall-category-3.png'
import haiou_category_4 from '../../../assets/haiou/mall-category-4.png'
import haiou_category_5 from '../../../assets/haiou/mall-category-5.png'
import haiou_category_6 from '../../../assets/haiou/mall-category-6.png'
import haiou_category_7 from '../../../assets/haiou/mall-category-7.png'
import haiou_category_8 from '../../../assets/haiou/mall-category-8.png'

// import categoryTea from '../../../assets/img/mall-category-tea.png'
// import categoryFarm from '../../../assets/img/mall-category-farm.png'
// import categoryArt from '../../../assets/img/mall-category-art.png'
import { requestCatalogData, setProductListIndex } from '../../../actions/mallAction'

let categoryIcon = {}
switch (process.env['REACT_APP_CHANNEL']) {
  case 'haiou':
    categoryIcon = {
      '首饰': haiou_category_1,
      '手串': haiou_category_2,
      '吊坠': haiou_category_3,
      '摆件': haiou_category_4,
      '把件': haiou_category_5,
      '农产品': haiou_category_6,
      '咖啡': haiou_category_7,
      '橡胶': haiou_category_8,
      'all': haiou_categoryAll
    }
    break
  // case 'xibei':
  // case 'xiniu':
  // case 'tradeasy':
  //
  //   break
  default:
    categoryIcon = {
      '首饰': xiniu_category_1,
      '手串': xiniu_category_2,
      '吊坠': xiniu_category_3,
      '摆件': xiniu_category_4,
      '把件': xiniu_category_5,
      '农产品': xiniu_category_6,
      '咖啡': xiniu_category_7,
      '橡胶': xiniu_category_8,
      '粮油': xiniu_category_9,
      '食品': xiniu_category_10,
      'all': xiniu_categoryAll
    }
}

@withRouter
@connect(state => {
  return state.mallCatalogs
})
class CatalogsBlock extends React.PureComponent {
  componentDidMount () {
    if (!(this.props.categories.length > 0)) {
      this.props.dispatch(requestCatalogData())
    }
  }

  render () {
    let { categories } = this.props
    return categories.length > 0
      ? <Categories>
        {categories.map(item => {
          return <Category iconSrc={categoryIcon[item.name]} onClick={this.toProductList.bind(this, item.id)}
                           title={item.name} key={item.id}/>
        })}
        <Category iconSrc={categoryIcon['all']} onClick={this.toProductList.bind(this, 'all')} title={'全部'}/>
      </Categories>
      : null
  }

  toProductList = (catalogId) => {
    // let path = window.PATH.MALL_PRODUCT_LIST
    // if (typeof catalogId === 'string' || typeof catalogId === 'number') {
    //   path = `${window.PATH.MALL_PRODUCT_LIST}?catalogId=${catalogId}`
    // }
    this.props.dispatch(setProductListIndex(catalogId))
    this.props.history.push(window.PATH.MALL_PRODUCT_LIST)
  }
}

export { CatalogsBlock }
